import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useResponsive } from '../../hooks/useResponsive';
import { Menu, X, Home, User, Settings, LogOut, Shield } from 'lucide-react';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isMobile } = useResponsive();
  const [menuOpen, setMenuOpen] = useState(false);
  const isAuthenticated = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setMenuOpen(false);
    navigate('/');
  };

  // Don't show header on home page
  if (location.pathname === '/') {
    return null;
  }

  return (
    <header style={{ 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: isMobile ? '12px 16px' : '16px 40px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }}>
      <div style={{ 
        maxWidth: '1600px',
        margin: '0 auto',
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center'
      }}>
        <div 
          style={{ 
            color: 'white', 
            fontSize: isMobile ? '18px' : '24px', 
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: isMobile ? '6px' : '8px'
          }}
          onClick={() => navigate(isAuthenticated ? '/managers' : '/')}
        >
          <span>⭐</span>
          <span>QR Review</span>
        </div>

        {isMobile ? (
          <>
            {/* Mobile Menu Button */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              style={{
                background: 'rgba(255,255,255,0.2)',
                border: '1px solid rgba(255,255,255,0.3)',
                borderRadius: '8px',
                padding: '8px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                color: 'white'
              }}
            >
              {menuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>

            {/* Mobile Menu Dropdown */}
            {menuOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                right: '16px',
                marginTop: '8px',
                background: 'white',
                borderRadius: '12px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                minWidth: '200px',
                overflow: 'hidden',
                zIndex: 1000
              }}>
                {isAuthenticated ? (
                  <>
                    <div style={{
                      padding: '16px',
                      borderBottom: '1px solid #e8ecf1',
                      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
                    }}>
                      <div style={{ 
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: '#2c3e50',
                        fontWeight: '600',
                        fontSize: '14px'
                      }}>
                        <User size={16} />
                        <span>{user.name || 'User'}</span>
                      </div>
                    </div>
                    {user.isAdmin && (
                      <button
                        onClick={() => {
                          navigate('/admin');
                          setMenuOpen(false);
                        }}
                        style={{
                          width: '100%',
                          padding: '14px 16px',
                          border: 'none',
                          background: 'white',
                          textAlign: 'left',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          fontSize: '14px',
                          color: '#2c3e50',
                          fontWeight: '500'
                        }}
                      >
                        <Shield size={16} color="#f57c00" />
                        <span>Admin Panel</span>
                      </button>
                    )}
                    <button
                      onClick={() => {
                        navigate('/managers');
                        setMenuOpen(false);
                      }}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: 'none',
                        background: 'white',
                        textAlign: 'left',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        fontSize: '14px',
                        color: '#2c3e50',
                        fontWeight: '500'
                      }}
                    >
                      <Home size={16} color="#667eea" />
                      <span>Dashboard</span>
                    </button>
                    <button
                      onClick={() => {
                        navigate('/business-profile');
                        setMenuOpen(false);
                      }}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: 'none',
                        background: 'white',
                        textAlign: 'left',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        fontSize: '14px',
                        color: '#2c3e50',
                        fontWeight: '500'
                      }}
                    >
                      <Settings size={16} color="#11998e" />
                      <span>Profile</span>
                    </button>
                    <div style={{ height: '1px', background: '#e8ecf1', margin: '4px 0' }} />
                    <button
                      onClick={handleLogout}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: 'none',
                        background: 'white',
                        textAlign: 'left',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        fontSize: '14px',
                        color: '#c62828',
                        fontWeight: '600'
                      }}
                    >
                      <LogOut size={16} />
                      <span>Logout</span>
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        navigate('/login');
                        setMenuOpen(false);
                      }}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: 'none',
                        background: 'white',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: '14px',
                        color: '#2c3e50',
                        fontWeight: '500'
                      }}
                    >
                      Login
                    </button>
                    <button
                      onClick={() => {
                        navigate('/signup');
                        setMenuOpen(false);
                      }}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: 'none',
                        background: 'white',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontSize: '14px',
                        color: '#667eea',
                        fontWeight: '600'
                      }}
                    >
                      Sign Up
                    </button>
                  </>
                )}
              </div>
            )}
          </>
        ) : (
          <nav style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            {isAuthenticated ? (
              <>
                {user.isAdmin && (
                  <button 
                    className="btn" 
                    style={{ 
                      background: 'rgba(255,215,0,0.3)', 
                      color: 'white',
                      border: '1px solid rgba(255,215,0,0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}
                    onClick={() => navigate('/admin')}
                  >
                    <Shield size={16} />
                    <span>Admin</span>
                  </button>
                )}
                <button 
                  className="btn" 
                  style={{ 
                    background: 'rgba(255,255,255,0.2)', 
                    color: 'white',
                    border: '1px solid rgba(255,255,255,0.3)'
                  }}
                  onClick={() => navigate('/managers')}
                >
                  Dashboard
                </button>
                <button 
                  className="btn" 
                  style={{ 
                    background: 'rgba(255,255,255,0.2)', 
                    color: 'white',
                    border: '1px solid rgba(255,255,255,0.3)'
                  }}
                  onClick={() => navigate('/business-profile')}
                >
                  Profile
                </button>
                <div style={{ 
                  color: 'white', 
                  padding: '8px 16px',
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  fontSize: '14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}>
                  <User size={16} />
                  <span>{user.name || 'User'}</span>
                </div>
                <button 
                  className="btn" 
                  style={{ 
                    background: 'white', 
                    color: '#667eea'
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <button 
                  className="btn" 
                  style={{ 
                    background: 'rgba(255,255,255,0.2)', 
                    color: 'white',
                    border: '1px solid rgba(255,255,255,0.3)'
                  }}
                  onClick={() => navigate('/login')}
                >
                  Login
                </button>
                <button 
                  className="btn" 
                  style={{ 
                    background: 'white', 
                    color: '#667eea'
                  }}
                  onClick={() => navigate('/signup')}
                >
                  Sign Up
                </button>
              </>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}

export default Header;
